import React, { useState, useEffect } from 'react';
import { Input } from 'reactstrap';

const CardNumberInput = ({ value, onChange, isCard, disabled, placeholder }) => {
    const [cardNumber, setCardNumber] = useState('');

    useEffect(() => {
        const formattedValue = isCard ? formatCardNumber(value) : value;
        setCardNumber(formattedValue);
    }, [value]);

    const handleChange = (event) => {

        const isBackspaceOrDelete = event.nativeEvent.inputType === 'deleteContentBackward' || event.nativeEvent.inputType === 'deleteContentForward';


        if (isBackspaceOrDelete) {
            // Filter and get only numbers and then remove last digit

            const numericValue = event.target.value.replace(/\D/g, '');


            const formattedValue = isCard ? formatCardNumber(numericValue) : numericValue;
            setCardNumber(formattedValue);
            onChange(formattedValue);
            return;
        }



        const inputValue = event.target.value;
        if (isCard && inputValue.replace(/[-*]/g, '').length > 16) {
            return;
        } else if (!isCard && inputValue.length > 20) {
            return;
        }
        onChange(inputValue);
    };

    const formatCardNumber = (inputValue) => {

        const numericValue = inputValue.replace(/\D/g, '');

        if (!numericValue || numericValue.length > 16) {
            return numericValue;
        }

        if (numericValue.length === 16 || numericValue.length % 4 === 0) {
            const formattedValue = numericValue.replace(/(\d{4})/g, '$1-');
            return formattedValue.endsWith('-')
                ? formattedValue.slice(0, -1)
                : formattedValue.replace(/-/g, ''); // Remove hyphens from the formatted value
        } else if (numericValue.length < 16) {
            const remainingDigits = 16 - numericValue.length;
            const placeholderValue = `${numericValue}${'*'.repeat(remainingDigits)}`;
            const formattedValue = numericValue.replace(/(\d{1,4})/g, '$1-');
            return formattedValue.endsWith('-')
                ? formattedValue.slice(0, -1)
                : formattedValue.replace(/-/g, ''); // Remove hyphens from the formatted value
        } else {
            return numericValue;
        }
    };

    return (
        <Input
            className="form-control-sm"
            type="text"
            value={cardNumber}
            disabled={disabled}
            onChange={(e) => {
                handleChange(e)
            }}

            placeholder={placeholder}
        />
    );
};

export default CardNumberInput;
